import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from './components/layout/Layout'
import { ROUTES } from './lib/routes'

const HomePage = lazy(() => import('./routes/HomePage'))
const ToolsPage = lazy(() => import('./routes/ToolsPage'))
const AboutPage = lazy(() => import('./routes/AboutPage'))
const PrivacyPage = lazy(() => import('./routes/PrivacyPage'))
const TermsPage = lazy(() => import('./routes/TermsPage'))

const MergePdfPage = lazy(() => import('./routes/tools/MergePdfPage'))
const SplitPdfPage = lazy(() => import('./routes/tools/SplitPdfPage'))
const CompressPdfPage = lazy(() => import('./routes/tools/CompressPdfPage'))
const PdfToJpgPage = lazy(() => import('./routes/tools/PdfToJpgPage'))
const JpgToPdfPage = lazy(() => import('./routes/tools/JpgToPdfPage'))
const RotatePdfPage = lazy(() => import('./routes/tools/RotatePdfPage'))
const DeletePdfPagesPage = lazy(() => import('./routes/tools/DeletePdfPagesPage'))
const SignPdfPage = lazy(() => import('./routes/tools/SignPdfPage'))

function RouteLoader() {
  return <div className="py-12 text-center text-sm text-slate-400">Loading…</div>
}

export default function App() {
  return (
    <Layout>
      <Suspense fallback={<RouteLoader />}>
        <Routes>
          <Route path={ROUTES.home} element={<HomePage />} />
          <Route path={ROUTES.tools} element={<ToolsPage />} />
          <Route path={ROUTES.mergePdf} element={<MergePdfPage />} />
          <Route path={ROUTES.splitPdf} element={<SplitPdfPage />} />
          <Route path={ROUTES.compressPdf} element={<CompressPdfPage />} />
          <Route path={ROUTES.pdfToJpg} element={<PdfToJpgPage />} />
          <Route path={ROUTES.jpgToPdf} element={<JpgToPdfPage />} />
          <Route path={ROUTES.rotatePdf} element={<RotatePdfPage />} />
          <Route path={ROUTES.deletePdfPages} element={<DeletePdfPagesPage />} />
          <Route path={ROUTES.signPdf} element={<SignPdfPage />} />
          <Route path={ROUTES.about} element={<AboutPage />} />
          <Route path={ROUTES.privacy} element={<PrivacyPage />} />
          <Route path={ROUTES.terms} element={<TermsPage />} />
          <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
        </Routes>
      </Suspense>
    </Layout>
  )
}
